import { format } from "date-fns";

/**
 * Sending a payment link from the user's OWN WhatsApp (wa.me): no business
 * number, template or 24-hour window involved, so it works in every
 * workspace — the same road the report share takes.
 */

export function buildPaymentLinkMessage(input: {
  name?: string | null;
  amount: number;
  url: string;
  expiresAt?: string | null;
}): string {
  const lines = [
    input.name ? `Hi ${input.name},` : "Hi,",
    "",
    `Here is your secure payment link for ₹${input.amount.toLocaleString("en-IN")}:`,
    input.url,
  ];
  if (input.expiresAt) {
    try {
      lines.push("", `The link is valid until ${format(new Date(input.expiresAt), "d MMM yyyy")}.`);
    } catch {
      /* no date line rather than a broken one */
    }
  }
  return lines.join("\n");
}

/**
 * Opens a WhatsApp chat with `digits` (international, digits only) and the
 * message typed in. Pass a window opened during the click when the URL is
 * only known after an await — browsers block a popup opened later.
 */
export function openWhatsappChat(digits: string, text: string, target?: Window | null) {
  const url = `https://wa.me/${digits}?text=${encodeURIComponent(text)}`;
  if (target && !target.closed) target.location.href = url;
  else window.open(url, "_blank", "noopener,noreferrer");
}
